export const HIDDEN_DISCONNECT_DELAY_MS = 2 * 60 * 1000;
